// ----------------------------------------------------------------------
export function card(_theme) {
    return {
        MuiCard: {
            styleOverrides: {
                root: {
                    position: "relative",
                    boxShadow: "0px 12px 24px -4px #919EAB1F, 0px 0px 2px 0px #919EAB33",
                    borderRadius: 16,
                    zIndex: 0, // Fix Safari overflow: hidden with border radius
                    padding: "12px 16px",
                },
            },
        },
        MuiCardHeader: {
            styleOverrides: {
                root: {
                    padding: "0px",
                    // padding: theme.spacing(1, 1.5, 1, 1.5),
                },
            },
        },
        MuiCardContent: {
            styleOverrides: {
                root: {
                    padding: "0px",
                    // padding: theme.spacing(1)
                },
            },
        },
    };
}
